export const logEntryTypeForValue = value => {
  let type
  switch (value) {
    case 1:
      type = 'Now'
      break
    case 2:
      type = 'Mindful Break'
      break
    case 3:
      type = 'Today Item'
      break
    case 4:
      type = 'Capture Item'
      break
    case 5:
      type = 'Manual Item'
      break
    default:
      type = 'Custom'
  }
  return type
}

export const TASK_TYPES = {
  custom: 1,
  break: 2,
  today: 3,
  capture: 4,
  created: 5,
}



// WEBPACK FOOTER //
// ./src/utils/logEntryType.js